import { pipe } from 'fp-ts/function';
import { createElement } from 'react';
import { connect } from 'react-redux';
import { initialize } from 'redux-form';
import { CommanderThunkDispatch } from '@mews-commander/types';
import { navigateInModal } from '../../../../../modules/app/actions/common';
import { openDialog } from '../../../../../modules/dialog/reducer';
import { formName, FormValues as PrintDialogFormValues } from '../PrintReasonDialogForm';
import { getPrintParams } from './PrintAction';
import { SendBillToCustomerAction } from './types';

interface SendBillToCustomerActionProps {
    action: SendBillToCustomerAction;
    component: React.ElementType;
    close: () => void;
    openPrintReasonDialog: (values: PrintDialogFormValues) => void;
    showPrintReasonDialog: boolean;
    setShowPrintReasonDialog: (show: boolean) => void;
    navigate: (url: string) => void;
}

const SendToCustomerAction = ({
    action,
    component,
    openPrintReasonDialog,
    showPrintReasonDialog,
    setShowPrintReasonDialog,
    navigate,
}: SendBillToCustomerActionProps) => {
    const handleClick = () => {
        const params = getPrintParams({ action });
        const { requirePrintReasonOnReprint, isReprint, reloadOnPrint, url } = action;

        if (showPrintReasonDialog || isReprint) {
            openPrintReasonDialog({
                printParams: params,
                type: 'send',
                pdfUrl: url,
                reloadOnPrint,
            });
        } else {
            navigate(url);

            if (requirePrintReasonOnReprint) setShowPrintReasonDialog(true);
        }
    };

    return createElement(component, {
        title: action.text,
        icon: action.icon,
        onClick: handleClick,
    });
};

export default pipe(
    SendToCustomerAction,
    connect(null, (dispatch: CommanderThunkDispatch) => ({
        openPrintReasonDialog: (values: PrintDialogFormValues) => {
            dispatch(openDialog(formName));
            dispatch(initialize(formName, values));
        },
        navigate: (url: string) => dispatch(navigateInModal(url)),
    }))
);
